<template>
    <div class="bank">
        <div class="bank_panel">
            <!-- <headerTop :title="$t('message.order.addAcard')" :clickRight="getCardId">
                
            </headerTop> -->
            <van-nav-bar class="global_pointer" :title="$t('message.order.addAcard')" size="40" :fixed="false" @click-right="getCardId" @click-left="$emit('close')">
                <template #left>
                    <span class="done">{{ 'Cancel' }}</span>
                </template>
                <template #right>
                    <span class="done">{{ $t('message.order.done') }}</span>
                </template>
            </van-nav-bar>
            <div class="bank-pic">
                <!-- <img src="" alt=""> -->
                <img src="https://fr-static.shopshops.top/20201221/cardPay.fdf5a1042fe9b6e9.png" alt="">
            </div>
            <div class="card-area">
                <span class="card">{{ $t('message.order.card') }}</span>
                <div id="card-element">
                    <!-- Elements will create input elements here -->
                </div>
                <!-- We'll put the error messages in this element -->
                <div id="card-errors" class="card-errors" role="alert"></div>
            </div>
            <div class="add global_pointer" @click="getCardId">{{ $t('message.order.done') }}</div>
        </div>
    </div>
</template>
<script>
import { STRIPE_KEY } from '@/config/index';
import { loadStripe } from '@stripe/stripe-js';
import { NavBar, Icon } from 'vant'
export default {
    data () {
        return {
            stripe: null,
            card: null,
        }
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon
    },
    mounted () {
        this.getCard()
    },
    methods: {
        async getCard() {
            this.$loading('loading...');
            const stripe = await loadStripe(STRIPE_KEY,{locale: 'en'});
            const elements = stripe.elements();
            this.stripe = stripe;
            this.$emit('generateStripe',stripe)
            // this.getStripe(stripe)
            let style = {
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                },
            };
            let card = elements.create('card', { style: style });
            card.mount('#card-element');
            this.card = card;
            this.$loading.close();
            card.addEventListener('change', ({ error }) => {
                const displayError = document.getElementById('card-errors');
                if (error) {
                    displayError.textContent = error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        },
        async getCardId() {
            this.$loading('loading...');
            try {
                const result = await this.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.card,
                    billing_details: {
                        // Include any additional collected billing details.
                        // name: 'Jenny Rosen',
                    },
                });
                this.$loading.close()
                const { paymentMethod = {}, error } = result || {};
                if (!paymentMethod.id) {
                    this.$loading.close();
                    this.$toast(this.$t('message.order.cardErrorToast'));
                    return;
                }
                if (error) {
                    console.log('card error', error);
                    return;
                }
                this.payMethod = paymentMethod;
                this.$emit('generatePayMethod',paymentMethod)
                this.$emit('close')
                // this.getPay(paymentMethod, this.card);
            } catch (error) {
                this.$loading.close();
                this.$toast(this.$t('message.order.cardErrorToast'));
                console.log(error);
            }
            
        },
    }
}
</script>
<style lang="less" scoped>
.bank {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    &_panel{
        position: absolute;
        width: 100%;
        bottom: 0;
        background-color: #ffffff;
        .done{
            color: rgb(25, 137, 250);
        }
        .bank-pic{
            padding: 100px 0 50px;
            text-align: center;
            img{
                width: 200px;
            }
        }
        .card-area{
            .card{
                display: inline-block;
                font-size: 16px;
                color: #333333;
                padding: 8px 16px;
            }
            #card-element{
                background: #ffffff;
                border: 1px solid #ededed;
                padding: 10px 5px;
            }
            .card-errors {
                font-size: 11px;
                color: #fa755a;
                padding: 5px;
            }
        }
        .add {
            margin: 50px auto;
            width: 75%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #333333;
            padding: 15px 0;
            color: #fff;
            font-size: 14px;
            border-radius: 5px;
        }
    }
}
</style>